<template>
  <div id="chequeo">
    <form autocomplete="off" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="separador"></div>
        <div class="separador"></div>
        <div id="icono" style="display: none;"><img width="100%" src="../assets/icono.png" /></div>
        <div id="indicaciones" style="display: none;">
          <div id="tarjeta" class="row">
            <div class="col-12 col-sm-4 col-lg-7 text-left">
              <img src="../assets/cedula.jpeg" alt class="img-fluid" />
            </div>
            <div class="col-12 col-sm-8 col-lg-5 text-left">
              <h5>Patente y Chasis</h5>
              <p style="font-size: 1.25em;">En el frente de la cédula de su vehículo, el número de patente se encuentra en el campo "DOMINIO" y el número de chasis (VIN) se encuentra en el campo "CHASIS".</p>
              <h6 v-if="0">Estimado Cliente, por tu seguridad te recordamos que:</h6>
              <ol v-if="0">
                <li>Autoahorro Volkswagen nunca te solicitará realizar pagos en efectivo, cobros o visitas a domicilio.</li>
                <li>Tampoco te solicitará realizar depósitos a números de CBU, ni en cuentas bancarias para operatorias que no estén específicamente definidas por Autoahorro en sus páginas web oficiales.</li>
                <li>Existen distintos medios de pago habilitados y te sugerimos por seguridad adherirte al débito automático para el pago mensual de cuotas y operar también a través de “Mi Plan” para descargar tus propios cupones de pago.</li>
                <li>No aceptes contactos ni envíes datos de tu tarjeta por redes sociales, whatsapp o similares.</li>
                <li>Ante cualquier duda sobre cómo o dónde efectuar un pago dirijite a tu Concesionario Oficial Volkswagen más próximo o comunicate con nuestro Call Center: CABA 0800-555-8922, Interior: 0810-555-8922, de Lunes a Viernes de 9:00 a 18:00 hs., o por correo electrónico a <a href="mailto:serviciosalcliente@vw.com.ar" class="azul">serviciosalcliente@vw.com.ar</a></li>
              </ol>
            </div>
          </div>
        </div>
        <div class="form-group col-md-5" :class="{'has-error' : errors.has('chasis'), 'has-success' : fields.chasis && fields.chasis.valid }">
          <float-label>
            <input type="text" name="chasis" id="chasis" class="form-control efecto" placeholder="Número de chasis*" v-model="chasis" v-validate="'alpha_num|max:20'" data-vv-as="chasis">
            <span class="focus-border"></span>
          </float-label>
          <div v-if="errors.has('chasis')" class="animated headShake bg-danger text-danger">{{ errors.first('chasis') }}</div>
        </div>
        <div id="yo" class="col-md-2">
          <p class="text-center">y/o</p>
        </div>
        <div class="form-group col-md-5" :class="{ 'has-error': errors.has('patente'), 'has-success' : fields.patente && fields.patente.valid  }">
          <float-label>
            <input type="text" name="patente" id="patente" class="form-control efecto" placeholder="Patente*" v-model="patente" v-validate="{ regex: /([A-Za-z]{3}\d{3})$|([A-Za-z]{2}\d{3}[A-Za-z]{2})$/ }" ref="patente" data-vv-as="patente">
            <span class="focus-border"></span>
          </float-label>
          <div v-if="errors.has('patente')" class="animated headShake bg-danger text-danger">{{ errors.first('patente') }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button type="submit" class="btn btn-default btn-primary" :disabled="cargando || errors.any() || (!chasis && !patente)"><span v-text="cargando ? 'Buscando' : 'Buscar'"></span></button>
        </div>
      </div>
    </form>
    <p style="padding: 20px 5px;">Las campañas informadas en este buscador corresponden a las comunicadas por Volkswagen Argentina S.A. a partir del año 2018. <br/>Para mayor información acerca de campañas de Recall anteriores a esa fecha, por favor comuníquese con el concesionario oficial Volkswagen de su preferencia.</p>
    <noscript>
      <img src="https://ad.doubleclick.net/ddm/activity/src=6703934;type=invmedia;cat=postv00e;u1=[SegmentContext/PartnerSegmentCode];u2=[EncryptedUserId];u3=[PH3];u4=[PH4];u5=[PH5];u6=[PH6];u7=[PH7];u8=[PH8];u9=[PH9];u10=[PH10];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>
    </noscript>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import FloatLabel from "vue-float-label/components/FloatLabel";
export default {
  name: "Chequeo",
  components: {
    FloatLabel
  },
  data() {
    return {
      chasis: "",
      patente: "",
      cargando: false,
      submitted: false,
      API_URL:
        window.location.hostname === "localhost"
          ? "http://eficiencia.test/api/recall"
          : "https://eficiencia-energetica.vwcontenidos.com.ar/api/recall",
    }
  },
  methods: {
    dispararEventos() {
      // console.log('agregar gtag y fbq');
      window.gtag("event", "conversion", {
        send_to: "AW-880716059/zIavCKSq14cCEJvS-qMD"
      });
      // window.fbq("track", "CompleteRegistration");
      window.gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'u1': '[SegmentContext\/PartnerSegmentCode]',
        'u10': '[PH10]',
        'u2': '[EncryptedUserId]',
        'u3': '[PH3]',
        'u4': '[PH4]',
        'u5': '[PH5]',
        'u6': '[PH6]',
        'u7': '[PH7]',
        'u8': '[PH8]',
        'u9': '[PH9]',
        'send_to': 'DC-6703934/invmedia/postv00e+standard'
      });
    },
    handleSubmit() {
      this.cargando = true;
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let form_data = new FormData();
          form_data.append("chasis", this.chasis);
          form_data.append("patente", this.patente);
          axios
            .post(this.API_URL, form_data, {
              headers: {
                "Content-type": "application/x-www-form-urlencoded"
              }
            })
            .then(res => {
              this.cargando = false;
              if (res.status === 200) {
                // this.dispararEventos();
                this.chasis = '';
                this.patente = '';
                if(res.data.revisiones.length)
                  this.mostrarLlamadas(res.data.revisiones, res.data.estado);
                else
                  this.mostrarVacio(res.data.estado)
              } else {
                swal({
                  animation: false,
                  type: "error",
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  text:
                    "Ocurrió un error, por favor intente nuevamente más tarde."
                });
              }
            })
            .catch(() => {
              swal({
                animation: false,
                type: "error",
                allowEscapeKey: false,
                allowOutsideClick: false,
                text:
                  "Ocurrió un error, por favor intente nuevamente más tarde."
              });
            });
        } else {
          this.cargando = false;
        }
      });
    },
    mostrarVacio(estado) {
      var icono = document.getElementById("icono").innerHTML;
      if(estado == 'no_vin') {    
        swal({
          // target: document.getElementById('app'),
          animation: false,
          width: "100%",
          html: '<div id="resultado">\
            <div class="row">\
              <div class="col-xs-12 text-left">\
                <h4>Nuestros registros indican que su vehículo no se encuentra alcanzado por una campaña de recall. Muchas gracias por su contacto. </h4>\
              </div>\
            </div>\
          </div>',
          showCloseButton: true,
          showCancelButton: false,
          // showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Solicitar turno en concesionaria',
          // cancelButtonText: 'Cerrar',
          // reverseButtons: true,
          focusConfirm: false,
          // showConfirmButton: false,
          onBeforeOpen: (modal) => {
            modal.setAttribute('id', 'no-tenes');
          }
        }).then((result) => {
          if (result.value) {
            var link = 'https://www.volkswagen.com.ar/app/formulario/vw-ar/contacteme/es/+/+/+/+/+/+/+/+/+/+/+/+/+/+/+';
            var win = window.open(link, '_blank');
            win.focus();
            // console.log('confirmado')
            // const el = document.getElementById('contact_form');
            // if (el) {
            //   setTimeout(function(){
            //     el.scrollIntoView({behavior: 'smooth'})
            //   }, 700)
            // }
          }
        });
      } else if(estado == 'no_patente') {
        swal({
          animation: false,
          width: "100%",
          html: '<div id="resultado">\
            <div class="row">\
              <div class="col-xs-12 text-left">\
                <h4>No hemos podido concluir la búsqueda con el número de patente de su vehículo. Por favor, intente nuevamente ingresando el número de chasis (VIN). <br/>Le pedimos disculpas por los inconvenientes ocasionados.</h4>\
              </div>\
            </div>\
          </div>',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          // showConfirmButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Volver a la búsqueda',
          onBeforeOpen: (modal) => {
            modal.setAttribute('id', 'no-tenes');
          }
        }).then((result) => {
          // if (result.value) {
          //   var link = 'https://www.volkswagen.com.ar/app/formulario/vw-ar/contacteme/es/+/+/+/+/+/+/+/+/+/+/+/+/+/+/+';
          //   var win = window.open(link, '_blank');
          //   win.focus();
          // }
        });
      } else {
        swal({
          animation: false,
          width: "100%",
          html: '<div id="resultado">\
            <div class="row">\
              <div class="col-xs-12 text-left">\
                <h4>No hemos podido concluir la búsqueda con los datos proporcionados.<br/>Le pedimos disculpas por los inconvenientes ocasionados.</h4>\
                <p>Para realizar los mantenimientos, podés comunicarte telefónicamente desde CABA o GBA al <strong>0800-555-8922</strong> o desde el interior al <strong>0810-555-8922</strong> de lunes a viernes de 09:00 a 18:00, o comunicarte con <a class="azul" mailto:"serviciosalcliente@vw.com.ar">serviciosalcliente@vw.com.ar</a></p>\
              </div>\
            </div>\
          </div>',
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          // showConfirmButton: false,
          showConfirmButton: true,
          confirmButtonText: 'Solicitar turno en concesionaria',
          onBeforeOpen: (modal) => {
            modal.setAttribute('id', 'no-tenes');
          }
        }).then((result) => {
          if (result.value) {
            var link = 'https://www.volkswagen.com.ar/app/formulario/vw-ar/contacteme/es/+/+/+/+/+/+/+/+/+/+/+/+/+/+/+';
            var win = window.open(link, '_blank');
            win.focus();
          }
        });
      }
    },
    mostrarLlamadas(llamadas, estado) {
      var revisiones = '';
      for (var i = 0; i < llamadas.length; i++) {
        if(llamadas[i].file)
          revisiones += '<p style="color: #001e50;">> <a target="_blank" style="color: #001e50; text-decoration: underline;" href="'+llamadas[i].file+'">Recall '+llamadas[i].recall+'</a></p>';
        else
          revisiones += '<p style="color: #001e50;">> Recall '+llamadas[i].recall+'</p>';
      //   revisiones += '<table>';
      //   revisiones += '<tr><th>Año modelo</th><td>'+llamadas[i].ano+'</td></tr>';
      //   revisiones += '<tr><th>Comercializado desde</th><td>'+llamadas[i].comercializacion_desde+'</td></tr>';
      //   revisiones += '<tr><th>Comercializado hasta</th><td>'+llamadas[i].comercializacion_hasta+'</td></tr>';
      //   revisiones += '<tr><th>Fabricado desde</th><td>'+llamadas[i].fabricacion_desde+'</td></tr>';
      //   revisiones += '<tr><th>Fabricado hasta</th><td>'+llamadas[i].fabricacion_hasta+'</td></tr>';
      //   revisiones += '<tr><th>Origen</th><td>'+llamadas[i].origen+'</td></tr>';
      //   revisiones += '<tr><th>Total vehículos afectados</th><td>'+llamadas[i].total+'</td></tr>';
      //   revisiones += '</table>';
      }
      var icono = document.getElementById("icono").innerHTML;
      if(estado == 'posteriores')
        var texto = '<h4>Su vehículo se encuentra alcanzado por la/s campaña/s de recall detallada/s a continuación.</h4><p>Le pedimos que se comunique con el concesionario oficial Volkswagen de su preferencia, para realizar, de forma gratuita, dicha actualización o verificar si la campaña fue realizada.</p>';
      else
        var texto = '<h4>Su vehículo se encuentra alcanzado por una campaña de recall vigente, comunicada por Volkswagen Argentina S.A. con anterioridad a 2018.</h4><p>Le pedimos que se comunique con el concesionario oficial Volkswagen de su preferencia, para obtener más información acerca de la campaña y realizar, de forma gratuita, dicha actualización o verificar si la campaña fue realizada.</p>';
      swal({
        animation: false,
        width: "100%",
        // customClass: {
        //   container: 'swal-small-container',
        //   popup: 'swal-small'
        // },
        html: '<div id="resultado">\
          <div class="row">\
            <div class="col-xs-12 col-sm-1 no-pad">'+icono+'</div>\
            <div class="col-xs-12 col-sm-11 text-left">'+texto+'</div>\
          </div>\
          <div class="row">\
            <div class="col-12">\
              <div id="revisiones">'+revisiones+'</div>\
            </div>\
          </div>\
        </div>',
        // footer: '<small class="text-left">Volkswagen Argentina S.A. informa a las autoridades competentes, a los propietarios y usuarios de vehículos Volkswagen Fox, Suran y Gol, comercializados en la República Argentina sobre una posible falla en el generador de gas del airbag del conductor y/o del pasajero de los mismos, según corresponda. Debajo se indican los números de chasis no consecutivos de los vehículos comprendidos. Luego de un análisis en laboratorio se ha detectado la posibilidad que, en algunos de estos vehículos, un lote de generador de gas pueda degradarse después de largos períodos de exposición de los vehículos a altas temperaturas, grandes amplitudes térmicas y alta humedad relativa del aire. Dichas condiciones pueden conducir a la ruptura del generador de gas, y en caso de deflagración del sistema de airbag ante un accidente vial con una desaceleración tal que produzca la apertura del airbag, el sistema puede proyectar fragmentos de metal dentro del vehículo, con riesgo de daños físicos o fatales para sus ocupantes. Aclaramos que esta posible falla no consiste en la “no apertura” del airbag ni en su apertura espontanea, sino en su posible apertura defectuosa en las condiciones indicadas. Volkswagen Argentina S.A. realizará la tarea correctiva en forma preventiva y gratuita a través de su Red de Concesionarios consiste en la verificación de los vehículos alcanzados y, en caso de ser necesario, el reemplazo de los generadores de gas de los airbags. Volkswagen Argentina S.A. iniciará la campaña a fin de implementar dicha solución en el mes de noviembre de 2020. Resulta importante destacar que no se han reportado accidentes relacionados con esta campaña en vehículos Volkswagen en la República Argentina ni en el resto del mundo. La presente campaña se llevará a cabo en todo el territorio nacional con el objetivo de preservar la seguridad y confiabilidad de los productos fabricados y comercializados por Volkswagen Argentina S.A., así como la satisfacción de nuestros clientes.</small>',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        // showConfirmButton: false
        showConfirmButton: true,
          confirmButtonText: 'Solicitar turno en concesionaria',
        }).then((result) => {
          if (result.value) {
            var link = 'https://www.volkswagen.com.ar/app/local/agendamiento-servicios-online/turnos';
            var win = window.open(link, '_blank');
            win.focus();
          }
        });
    },
    cerrarTodo() {
      alert('cerrar')
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  transition: all 0.3s ease;
}

.text-danger {
  padding: 0.5em;
  border-radius: 4px;
}

textarea {
  min-width: 100%;
  max-width: 100%;
}

button:focus {
  outline: none !important;
}

#yo {
  text-align: center;
  @media(max-width: 767px) {
    text-align: left;
    margin-bottom: 2em;
  }
  p {
    margin: -10px 0 15px;
    line-height: 3.3em;
    border: 1px solid #001e50;
    display: inline-block;
    width: 3.5em;
    border-radius: 50%;
    height: 3.5em;
    color: #001e50;
    @media(max-width: 769px) {
      margin: 15px 0 0;
      font-size: 1.25em;
    }
  }
}

form {
  padding: 0 5px;
  @media (max-width: 767px) {
    padding: 0 5%;
  }
  & > .row.margin {
    margin-bottom: 6.7em;
  }
  & > .row:not(.margin) {
    // margin-bottom: 0.8em;
  }
  h3 {
    font-size: 2.3em;
    font-family: "vw-head", Arial, Helvetica, sans-serif;
    font-weight: 400;
    letter-spacing: -0.04em;
    margin-bottom: 1.55em;
  }
  input,
  select,
  textarea {
    color: #001e50;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    box-shadow: none;
    border-radius: 0;
    font-size: 1.2em;
    padding: 0;
    letter-spacing: -0.035em;
    @media(max-width: 767px) {
      font-size: 1.4em;
      letter-spacing: 0.005em;
    }
    &:hover,
    &:focus {
      box-shadow: none;
    }
    &:focus {
      outline: none;
      border-color: #9b9b9b;
    }
    &.efecto ~ .focus-border {
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 1px;
      background-color: #001e50;
      transition: 0.4s;
    }
    &.efecto:focus ~ .focus-border {
      width: 100%;
      transition: 0.4s;
      left: 0;
    }
  }
  select {
    -webkit-appearance: none;
    appearance: none;
  }
  textarea {
    resize: none;
    margin-top: 0.3em;
    height: 1.6em;
  }
  .separador,
  .separador2 {
    display: block;
    height: 1.4em;
    @media(max-width: 767px) {
      height: 0.6em;
    }
  }
  .separador2 {
    height: 7em;
  }
  #legal {
    margin-top: 6.7em;
    font-size: 1.4em;
    line-height: 1.3em;
    letter-spacing: -0.022em;
    font-weight: 200;
  }
  .checkbox {
    color: #001e50;
    font-size: 1.4em;
    margin-top: 2.1em;
    @media (max-width: 669px) {
      font-size: 1.8em;
    }
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    label {
      padding-left: 2em;
      vertical-align: text-bottom;
      line-height: 0.6em;
      letter-spacing: -0.007em;
      @media (max-width: 1441px) {
        line-height: 1.4em;
      }
      @media (max-width: 669px) {
        line-height: 0.3em;
      }
    }
    .checkbox-custom {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 24px;
      width: 24px;
      background-color: transparent;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
      border: 2px solid #001e50;
      border-radius: 0;
    }
    input:checked ~ .checkbox-custom {
      background-color: #001e50;
      -webkit-transform: rotate(0deg) scale(1);
      -ms-transform: rotate(0deg) scale(1);
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 2px solid #001e50;
    }
    .checkbox-custom::after {
      position: absolute;
      content: "";
      left: 12px;
      top: 12px;
      height: 0px;
      width: 0px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(0deg) scale(0);
      -ms-transform: rotate(0deg) scale(0);
      transform: rotate(0deg) scale(0);
      opacity: 1;
      transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -ms-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }
    input:checked ~ .checkbox-custom::after {
      -webkit-transform: rotate(45deg) scale(1);
      -ms-transform: rotate(45deg) scale(1);
      transform: rotate(45deg) scale(1);
      opacity: 1;
      left: 8px;
      top: 3px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .btn.btn-primary {
    border-radius: 22px;
    margin: 7px 14px;
    font-size: 1.2em;
    padding: 0.4em 5.4em 0.6em;
    letter-spacing: -0.04em;
    color: #fff;
    background: #001e50;
    border: 1px solid #fff;
    &:focus,
    &:active {
      box-shadow: none;
      outline: none;
    }
    @media (max-width: 767px) {
      display: block;
      width: 94%;
      font-size: 1.4em;
      padding: 0.7em;
      margin: 1.3em 3.5%;
    }
  }
  .relative {
    position: relative;
  }
  .has-success .form-control,
  .has-success .form-control:focus,
  .has-error .form-control,
  .has-error .form-control:focus {
    box-shadow: none;
    border-color: #9b9b9b;
  }

  .text-danger {
    background: white;
    color: #dd2c00;
    padding: 2px;
  }
}
#revision {
  font-size: 1.3em;
  margin: 3.7em 5px 6.7em;
  letter-spacing: 0.007em;
  @media(max-width: 767px) {
    font-size: 1.1em;
    margin: 1em 4%;
    letter-spacing: -0.01em;
    color: #001e50;
  }
}
#tarjeta {
  display: flex;
  align-items: center;
  @media(max-width: 767px) {
    flex-direction: column-reverse;
    .col-sm-8 {
      padding: 0 8% 0 11%;
    }
  }
}
</style>
